export const TIMEZONE_HEADER = 'X-Timezone';

export function getBrowserTimeZone(): string | undefined {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone || undefined;
  } catch {
    return undefined;
  }
}
